import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { Label, FormFeedback } from 'reactstrap';

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"

class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            solicitud_id: null,
            proyecto_codigo: "",
            campos: []
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    setSelects(data) {
        this.setState({
            solicitud_id: data.solicitud_id,
            proyecto_codigo: data.solicitud_codigo,
            campos: data.campos
        });
    }

    resetState() {
        this.setState({
            solicitud_id: null,
            proyecto_codigo: "",
            campos: []
        });
    }

    onCheckBoxClick(i) {
        let campos = this.state.campos;
        campos[i].imprimir = (campos[i].imprimir ? false : true);
        this.setState({ campos: campos });
    }

    render() {
        return (
            <ParadigmaModal
                fileDownloader={true}
                fileName={"Plan de Trabajo.docx"}
                downloadUrl={api.proyectos.plandetrabajo.downloaddoc}
                getUrl={api.proyectos.plandetrabajo.generardoc}
                postUrl={api.proyectos.plandetrabajo.generardoc}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"El Documento del Plan de Trabajo ha sido generado con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Generar Documento del Plan de Trabajo"}
                buttonTitle={"Generar Documento del Plan de Trabajo"}
                buttonIcon={"fa fa-file fa-lg"}
                className={"ui-modal-dialog ui-modal-md"}
                saveButton={true}
                closeButton={true}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.resetState()}
            >
                <div className="ui-form">
                <p className="ui-section-label">Datos del proyecto</p>
                <div className="ui-row-1">
                    <div className="ui-field">
                        <Label>Código</Label>
                        <ParadigmaAsyncSeeker pkField={"codigo"} nombreField={"codigo"} fieldName={""} url={api.proyectos.solicitudes.selectcodigo} value={this.state.proyecto_codigo} disabled={true} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </div>
                </div>
                <div className="ui-row-1">
                    <div className="ui-field">
                        <Label>Proyecto</Label>
                        <ParadigmaAsyncSeeker fieldName={"solicitud_id"} url={api.proyectos.solicitudes.select} value={this.state.solicitud_id} disabled={true} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </div>
                </div>
                <div className="ui-divider"></div>
                <div className="ui-row-1">
                    <div className="ui-field">
                        <Label>Seleccione los datos a exportar</Label>
                        <table>
                            <thead>
                                <tr>
                                    <th>Pestañas</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.campos.map((x, i) =>
                                    <tr key={i}>
                                        <td>
                                            <Label>
                                                {!x.obligatorio ? <input readOnly={true} onChange={(e) => { return; }}
                                                    onClick={(value) => this.onCheckBoxClick(i)} type={"checkbox"} checked={x.imprimir} /> : null}
                                                {(x.imprimir || x.obligatorio) && <input hidden={true} value={x.id} name={"campos[" + i + "]"} />}
                                                {x.nombre}
                                            </Label>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento2/DescargarDoc.js